import { Box, Button, Icon } from '@mui/material';
import FontAwesomeSvgIcon from 'components/shared/FontAwesomeSvgIcon';
import { t } from 'i18next';
import { faFilterList } from 'vendors/@fortawesome/pro-light-svg-icons';

type FilterButtonProps = {
  handleMoreFilters: () => void;
  showMoreFilters: boolean;
};

const FilterButton = ({
  handleMoreFilters,
  showMoreFilters
}: FilterButtonProps) => {
  return (
    <Box width="max-content" marginY={1} maxWidth={200}>
      <Button
        variant="contained"
        sx={{
          width: 'fit-content',
          display: 'flex',
          justifyContent: 'space-between',
          gap: 1.25
        }}
        color="inherit"
        onClick={handleMoreFilters}
      >
        <Icon sx={{ lineHeight: 0 }}>
          <FontAwesomeSvgIcon
            icon={faFilterList}
            fontSize="inherit"
            color="action"
          />
        </Icon>
        {showMoreFilters
          ? t('flexHistory.lessFilters')
          : t('flexHistory.moreFilters')}
      </Button>
    </Box>
  );
};

export default FilterButton;
